export type PageResult<T> = {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
};

export type FlowPageAction = {
  actionCode: string;
  label: string;
  emphasis: 'default' | 'primary' | 'danger';
  requiresComment: boolean;
  operationType:
    | 'SHELL_LOCAL'
    | 'WORKFLOW'
    | 'DRAFT_WORKFLOW';
};

export type DraftFlowPageContext = {
  contextType: 'DRAFT';
  applicationCode: string;
  processId: string;
  businessTaskId: string;
  businessObjectType: string;
  businessObjectPublicId: string;
  pageRoute: string;
  availableActions: FlowPageAction[];
  workItemContext: null;
  draftContext: {
    draftPublicId: string;
    expectedDraftVersion: number;
    ownerPublicId: string;
    lastSavedAt: string;
    expiresAt: string;
    draftStatus: string;
    projectionHealth: string;
  };
};

export type PortalDraftListItem = {
  draftPublicId: string;
  applicationCode: string;
  applicationName: string;
  processId: string;
  processName: string;
  businessObjectType: string;
  businessObjectPublicId: string;
  title: string;
  summaryItems: Array<{ label: string; value: string }>;
  projectionHealth: string;
  draftStatus: string;
  lastSavedAt: string;
  expiresAt: string;
  version: number;
};

export type PortalDraftDetail = {
  summary: PortalDraftListItem;
  flowPageContext: DraftFlowPageContext;
};

export type TenantApplication = {
  applicationPublicId: string;
  tenantName: string;
  tenantTypePublicId: string;
  tenantTypeName?: string;
  managerUsername: string;
  managerFullName: string;
  applicationStatus: string;
  version: number;
};

export type TenantApplicationValues = {
  tenantName: string;
  tenantTypePublicId: string;
  managerUsername: string;
  managerFullName: string;
  managerInitialPassword?: string;
};

export type DraftSaveResult = {
  draftPublicId: string;
  businessObjectPublicId: string;
  receiptPublicId: string;
  saveSequence: number;
  receiptStatus: string;
  expectedDraftVersion: number;
  lastSavedAt: string;
  expiresAt: string;
  replayed: boolean;
};

export type TenantApplicationDraftResult = {
  application: TenantApplication;
  draft: DraftSaveResult;
};

export type DraftConversionResult = {
  draftPublicId: string;
  processInstancePublicId: string;
  status: string;
  replayed: boolean;
};

export function formatShanghai(value?: string) {
  if (!value) return '-';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value)).replaceAll('/', '-');
}
